import React from 'react';
import OurHeader from "./header/OurHeader";
import Copyright from "./footer/Copyright";

const Layout = ({children}) => {
    return (
        <>
            <main className="page-wrapper">
                <OurHeader btnStyle="btn-small round btn-icon" HeaderSTyle="header-not-transparent"/>
                {children}
                <Copyright/>
            </main>
        </>
    )
}
export default Layout;
